/**
 * Created by nir on 20/07/2016.
 */

if (window.jQuery) {
    window.jQuery(function ($) {


        var mobileGenres = $('#mobile-genres'),
            nav = $('nav#top-nav');

        // genre click tracking
        nav.on('click', '.genre-icons li a[href]', function () {
            var genre = $(this).find('.genre-name').text().trim();
            TCT.debug('Nav button clicked', genre, this);
            if (genre) trackCTA('TopNav_GenreButton', genre);
            return true;
        });

        mobileGenres.on('scroll', function () {
            var atStart = mobileGenres[0].scrollLeft == 0,
                atEnd = mobileGenres[0].scrollLeft == (mobileGenres[0].scrollWidth - mobileGenres[0].clientWidth);

            nav.toggleClass('at-start', atStart).toggleClass('at-end', atEnd);
        });

    });
}


//// ANGULAR
var subNavApp = angular.module('subNavApp', []);

subNavApp.controller('subNavControll', ['$scope', '$log', '$http', '$window', function ($scope, $log, $http, $window) {

    //create vertical articles and genre articles objects
    $scope.verticalarticles = {};
    $scope.genresarticles = {};

    // number of characters limitation for the articles' titles in the subnav
    $scope.limitnum = 75;
    $scope.trackCTA = $window.trackCTA;
    $scope.showprogress = true;
    $scope.showloadingbtn = true;

    $scope.init = function (locationID, articlesPerGenre, verticals, sponsoredLabel, vertical, type, hp, limit) {
        $scope.locationID = locationID;
        $scope.articlesPerGenre = articlesPerGenre;

        if (parseInt(hp)) {
            $scope.hp = "&hp=1";
        } else {
            $scope.hp = "&hp=0";
        }
        if (parseInt(limit)) {
            $scope.limit = "&limit="+limit;
        } else {
            $scope.limit = "";
        }

        $scope.verticals = verticals.split(",").map(function (item) {
            return parseInt(item);
        });
        $scope.sponsoredLabel = sponsoredLabel;

        $scope.vertical = vertical;

        $scope.pageType = type;

        $http.get(TCTServer.api + 'v1/articles/locations/' + $scope.locationID + '?data=true&postPerCategory=' + $scope.articlesPerGenre + '&queryType=topNav&category=' + $scope.vertical + $scope.hp + $scope.limit).then(function (response) {
            var data = response.data;

            if($scope.pageType == "Home"){
                $scope.genresarticles['genre_99999'] = [];
                $scope.firstTwo = [];
            }

            i = 0;

            //create verticals articles
            angular.forEach(data['articleResources'], function ($value) {

                if ($scope.verticals.indexOf($value.groupID) > -1) {
                    if (!$scope.verticalarticles.hasOwnProperty($value.groupID)) {
                        $scope.verticalarticles[$value.groupID] = [];
                    }
                    if ($scope.verticalarticles[$value.groupID].length < $scope.articlesPerGenre) {

                        if ($value.isSponsored == true) {
                            $value.articleCategory = $scope.sponsoredLabel;
                        }
                        $scope.verticalarticles[$value.groupID].push($value);
                    }
                }
            });

            //create genres articles
            angular.forEach(data['articleResources'], function ($value) {


                // FOR THE TWO VERTICALS REMAINING, WE BUILD IT THE OLD WAY
                if($scope.pageType == "Vertical" || $scope.pageType == "Vertical-Location" ) {
                    if (!$scope.genresarticles.hasOwnProperty('genre_' + $value.categoryID)) {
                        $scope.genresarticles['genre_' + $value.categoryID] = [];
                    }
                    if ($scope.genresarticles['genre_' + $value.categoryID].length < $scope.articlesPerGenre)
                        $scope.genresarticles['genre_' + $value.categoryID].push($value);

                }else if ($scope.pageType == "Home"){

                    if($value.isSponsored == true){
                        $value.homeSponsored = $scope.sponsoredLabel;
                    }else{
                        $value.homeSponsored = "";
                    }
                    $scope.genresarticles['genre_99999'].push($value);


                }else{
                    if($scope.verticals.indexOf($value.groupID)>-1){

                        if (!$scope.genresarticles['genre_' + $value.groupID]) {
                            $scope.genresarticles['genre_' + $value.groupID] = [];
                        }

                        if ($scope.genresarticles['genre_' + $value.groupID].length < $scope.articlesPerGenre)
                            $scope.genresarticles['genre_' + $value.groupID].push($value);


                    }
                }



                if ($scope.pageType == "Home" && i < 2){
                    if($scope.genresarticles['genre_'+$scope.vertical]){
                        $scope.genresarticles['genre_'+$scope.vertical].shift();
                    }

                    if($value.isSponsored == true){
                        $value.homeSponsored = $scope.sponsoredLabel;
                    }else{
                        $value.homeSponsored = "";
                    }
                    $scope.firstTwo.push($value);

                }

                i++;
            });



            $scope.showprogress = false;
            $scope.showloadingbtn = false;


        }, function (errors) {
            TCT.warn('API call error', errors);
            $scope.showprogress = false;
        });
    }
}]);

// a limit filter for angular. recieves the VALUE you want to limit
//WORDWISE - true or false, determines if the text will be cut mid-word of after a word
// MAX - number of maximum characters for your value.
// TAIL - an addition you may want to add to the cut value (could be "read more" or something similar, default is ...)
angular.module('subNavApp').filter('cut', function () {
    return function (value, wordWise, max, tail) {
        if (!value) return '';

        max = parseInt(max, 10);
        if (!max) return value;
        if (value.length <= max) return value;

        value = value.substr(0, max);

        if (wordWise) {
            var lastSpace = value.lastIndexOf(' ');

            if (lastSpace !== -1) {
                //Also remove . and , so its gives a cleaner result.
                if (value.charAt(lastSpace - 1) === '.' || value.charAt(lastSpace - 1) === ',') {
                    lastSpace = lastSpace - 1;
                }
                value = value.substr(0, lastSpace);
            }
        }

        return value + (tail || ' …');
    };
});

angular.bootstrap(document.getElementById('locationVertical'), ['subNavApp']);
angular.bootstrap(document.getElementById('genre-sections'), ['subNavApp']);
